export const clearCookie = (name, path = '/', domain = '') => {
    // Validate inputs to prevent security issues
    if (!name || typeof name !== 'string') {
        console.error('Invalid cookie name provided');
        return;
    }
    
    // Validate path (should start with / and not contain special characters)
    const validPath = path && typeof path === 'string' && path.startsWith('/') ? 
        path.replace(/[^\w\d/.-]/g, '') : '/';
    
    // Validate domain (should be a valid domain format)
    let validDomain = '';
    if (domain && typeof domain === 'string') {
        // Simple domain validation - only allow letters, numbers, dots, and hyphens
        const sanitizedDomain = domain.replace(/[^\w\d.-]/g, '');
        validDomain = sanitizedDomain.length > 0 ? sanitizedDomain : '';
    }
    
    // Set expiration to past date and include path/domain if provided
    const cookieString = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${validPath};`;
    document.cookie = validDomain ? `${cookieString}domain=${validDomain};` : cookieString;
}

export const clearAllCookies = () => {
    try {
        // Get all cookies from document.cookie
        document.cookie.split(";").forEach(cookie => {
            if (cookie.trim()) {
                const eqPos = cookie.indexOf("=");
                // Handle case where there might not be a "=" character
                const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
                
                // Clear cookie for common paths and the current domain
                clearCookie(name);
                clearCookie(name, '/');
                
                // If on a subdomain, try clearing for the main domain too
                const domain = window.location.hostname;
                if (domain.indexOf('.') !== -1) {
                    const mainDomain = domain.substring(domain.indexOf('.'));
                    clearCookie(name, '/', mainDomain);
                }
            }
        });
    } catch (error) {
        // Throw the error instead of just logging it
        throw new Error(`Failed to clear cookies: ${error.message}`);
    }
}